import useLocale from 'next-translate/useTranslation';

import { useChannelsT } from '../useChannelsT';

/** Questions every site-builder page answers the same way. */
export function useWebsiteFaqs() {
  const { t } = useChannelsT();
  const { t: tc } = useLocale('chatbots');

  return [
    {
      question: t('Is the website chatbot free?'),
      answer: t(
        'Yes. The website chat works on every plan, including Free. Buttons, forms and bookings are actions, which need a paid plan.',
      ),
    },
    {
      question: t('Will it slow down my site?'),
      answer: t(
        'No. The bubble shows as soon as the page loads, and the chat itself loads in the background once the page has settled.',
      ),
    },
    {
      question: t('Can I change how the chat looks?'),
      answer: t(
        'Yes. Pick the position, icon, color and greeting in Appearance. Your site updates within about a minute, with no new code.',
      ),
    },
    {
      question: tc('What can my agent learn from?'),
      answer: tc(
        'Websites and sitemaps, PDF, Word, CSV, TXT and EPUB files, YouTube videos, plain text and Q&A pairs. You can retrain it with one click whenever something changes.',
      ),
    },
    {
      question: t('Can visitors talk to it by voice?'),
      answer: t(
        'Yes, on Unlimited 200 and up: visitors tap Talk in the chat and speak. On other plans, you can try voice calls in the Playground.',
      ),
    },
    {
      question: t('Which languages does it speak?'),
      answer: t(
        'It replies in the language each customer writes in, more than 80 of them, from the same knowledge.',
      ),
    },
  ];
}
